import * as yup from "yup";

/*
 *
 * @helper schemas
 *
 */
const imageValidationSchema = yup
  .mixed()
  .test("fileType", "Unsupported image format", (value) => {
    if (typeof value === "string") return true; // Skip validation if it's a string
    if (value === null || value === undefined) return true;
    return (
      value instanceof File &&
      ["image/jpeg", "image/png", "image/gif"].includes(value.type)
    );
  })
  .test("fileSize", "File is too large", (value) => {
    if (typeof value === "string") return true; // Skip validation if it's a string
    if (value === null || value === undefined) return true;
    return value instanceof File && value.size <= 1 * 1024 * 1024; // 5 MB limit
  });

/*
 *
 * @Used schemas
 *
 *
 */
const createAuthorSchema = yup.object({
  user: yup.string().uuid("User is required").required("User is required"),
  display_name: yup.string().required("Display name cannot be empty"),
  summery: yup.string(),
  preview_image: imageValidationSchema.nullable(),
});

const createTagSchema = yup.object({
  name: yup.string().required("Tag name is required"),
  description: yup.string(),
  preview_image: imageValidationSchema.nullable(),
});

const createCategorySchema = yup.object({
  name: yup.string().required("Category name is required"),
  description: yup.string(),
  preview_image: imageValidationSchema.nullable(),
});

const createPostSchema = yup.object({
  headline: yup.string().required("Post headline is required"),
  content: yup.string().required("Post content cannot be empty"),
  table_of_content: yup.string().nullable(),
  author: yup
    .string()
    .uuid("Author is required")
    .required("Author is required")
    .typeError("Invalid selection"),
  preview_image: imageValidationSchema.nonNullable("Image cannot be empty"),
  tag: yup
    .array(
      yup.object({
        value: yup.string().uuid(),
        label: yup.string(),
      })
    )
    .min(1, "Tag cannot be empty")
    .required("Tag cannot be empty"),
  category: yup
    .array(
      yup.object({
        value: yup.string().uuid(),
        label: yup.string(),
      })
    )
    .min(1, "Category cannot be empty"),
});

const remarksValidation = yup.object().shape({
  comment: yup.string().required("Remarks is required"),
});

export interface IAuthorSchema
  extends yup.InferType<typeof createAuthorSchema> {}
export interface ITagSchema extends yup.InferType<typeof createTagSchema> {}
export interface ICategorySchema
  extends yup.InferType<typeof createCategorySchema> {}
export interface IPostSchema extends yup.InferType<typeof createPostSchema> {}

export {
  createAuthorSchema,
  createPostSchema,
  createTagSchema,
  createCategorySchema,
  remarksValidation,
};
